import React from 'react';
import { Typography, makeStyles, Grid, Tooltip } from '@material-ui/core';
import Moment from 'react-moment';
import { PictureAsPdf, Cancel, Extension, TimerOutlined, TimerOffOutlined } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import { CONSTANTS } from '../../../constants/constants';
import useWindowSize from '../../../customHooks/useWindowSize';
import GraphqlApi from '../../../api-graphql';
import Tags from '../../Tags';

const useStyles = makeStyles((theme) => ({
  container: {
    margin: '8px'
  },
  errorIcon: {
    color: '#B00020',
    verticalAlign: 'middle',
    marginRight: 12
  },
  warningIcon: {
    color: '#e39400',
    verticalAlign: 'middle',
    marginRight: 12
  },
  errorMessage: {
    fontSize: 12,
    textTransform: 'uppercase',
    color: '#B00020',
    verticalAlign: 'middle'
  },
  warningMessage: {
    fontSize: 12,
    textTransform: 'uppercase',
    color: '#e39400',
    verticalAlign: 'middle'
  },
  tooltipWidthDesktop: {
    maxWidth: 500
  },
  tooltipWidthMobile: {
    maxWidth: 300
  }
}));

const DocumentDescription = (props) => {
  const { document, showImage, enableTags } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  const windowSize = useWindowSize();

  const delay = 200;
  const touchDelay = 300;
  const placement = 'bottom-start';
  const tooltipWitdh = (windowSize.width > 500 ? classes.tooltipWidthDesktop : classes.tooltipWidthMobile);

  const flow = JSON.parse(document.flow);

  return (
    <Grid
      container
      wrap='nowrap'
    >
      {showImage && <PictureAsPdf style={{ fontSize: 75, paddingRight: 15 }} />}
      <div style={{ overflow: 'hidden', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <Tooltip title={document.name} enterDelay={delay} enterTouchDelay={touchDelay} placement={placement} classes={{ tooltip: tooltipWitdh }}>
          <Typography variant='subtitle1' style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }} >
            {document.name}
          </Typography>
        </Tooltip>
        <Tooltip title={document.description} enterDelay={delay} enterTouchDelay={touchDelay} placement={placement} classes={{ tooltip: tooltipWitdh }}>
          <Typography variant='body2' style={{ marginTop: 5, textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
            {document.description}
          </Typography>
        </Tooltip>
        <Typography variant='body2'>
          <Moment format='DD/MM/YYYY HH:mm:ss'>{document.updatedAt}</Moment>
        </Typography>
        {(flow && (document.status === CONSTANTS.DOCUMENT.STATUS.REJECTED || document.status === CONSTANTS.DOCUMENT.STATUS.CANCELLED || document.status === CONSTANTS.DOCUMENT.STATUS.ERROR)) && (
          <Typography className={classes.container} variant='subtitle2'>
            <Cancel className={classes.errorIcon} />
            <span className={classes.errorMessage}>{t(`documentDescription:${document.status}`)}</span>
          </Typography>
        )}
        {(flow && flow.status === 'sendToSign' && flow.expirationDate) && (
          <Typography className={classes.container} variant='subtitle2'>
            <TimerOutlined className={classes.warningIcon} />
            <span className={classes.warningMessage}>
              {t(`documentDescription:expires`)}
              <Moment format='DD/MM/YYYY HH:mm:ss' unix>{flow.expirationDate}</Moment>
            </span>
          </Typography>
        )}
        {(flow && flow.status === 'expired') && (
          <Typography className={classes.container} variant='subtitle2'>
            <TimerOffOutlined className={classes.errorIcon} />
            <span className={classes.errorMessage}>
              {t(`documentDescription:expired`)}
              <Moment format='DD/MM/YYYY HH:mm:ss' unix>{flow.expirationDate}</Moment>
            </span>
          </Typography>
        )}
        {!document.fileUrl &&
        <Typography className={classes.container} variant='subtitle2'>
          <Extension className={classes.warningIcon} />
          <span className={classes.warningMessage}>{t(`documentDescription:byApi`)}</span>
        </Typography>}
        {enableTags &&
        <Typography className={classes.containerTags} variant='subtitle2'>
          <Tags item={document} update={GraphqlApi.updateDocument} />
        </Typography>
        }
      </div>
    </Grid>
  );
};

export default DocumentDescription;
